module.exports = __webpack_public_path__ + "25335aaa55e1ccfdf032bb7558ae2104.MP3";